import React, { useState, useContext, createContext } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

// Context to manage global success state
const SuccessDialogContext = createContext<{
  showSuccess: (message: string) => void;
}>({} as { showSuccess: (message: string) => void });

export const useSuccessDialog = () => useContext(SuccessDialogContext);

const SuccessDialogProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const showSuccess = (message: string) => {
    setSuccessMessage(message);
    setOpen(true);
  };

  return (
    <SuccessDialogContext.Provider value={{ showSuccess }}>
      {children}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="success-dialog-title"
        aria-describedby="success-dialog-description"
      >
        <DialogTitle id="success-dialog-title">Success</DialogTitle>
        <DialogContent>
          <DialogContentText id="success-dialog-description">
            {successMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </SuccessDialogContext.Provider>
  );
};

export default SuccessDialogProvider;
